import React, { useState } from 'react';
import { ReactComponent as ArrowIcon } from './Arrow.svg';
import css from './SectionTestimonials.module.css';

const SectionTestimonials = (props) => {
    const { intl } = props;

    const items = [
        {
            name: intl.formatMessage({ id: 'MLP.testimonials.t1.name' }),
            desc: intl.formatMessage({ id: 'MLP.testimonials.t1.desc' }),
            content: intl.formatMessage({ id: 'MLP.testimonials.t1.text' }),
        },
        {
            name: intl.formatMessage({ id: 'MLP.testimonials.t2.name' }),
            desc: intl.formatMessage({ id: 'MLP.testimonials.t2.desc' }),
            content: intl.formatMessage({ id: 'MLP.testimonials.t2.text' }),
        },
        {
            name: intl.formatMessage({ id: 'MLP.testimonials.t3.name' }),
            desc: intl.formatMessage({ id: 'MLP.testimonials.t3.desc' }),
            content: intl.formatMessage({ id: 'MLP.testimonials.t3.text' }),
        },
        {
            name: intl.formatMessage({ id: 'MLP.testimonials.t4.name' }),
            desc: intl.formatMessage({ id: 'MLP.testimonials.t4.desc' }),
            extra: intl.formatMessage({ id: 'MLP.testimonials.t4.extra' }),
            content: intl.formatMessage({ id: 'MLP.testimonials.t4.text' }),
        },
        {
            name: intl.formatMessage({ id: 'MLP.testimonials.t5.name' }),
            desc: intl.formatMessage({ id: 'MLP.testimonials.t5.desc' }),
            content: intl.formatMessage({ id: 'MLP.testimonials.t5.text' }),
        },
        {
            name: intl.formatMessage({ id: 'MLP.testimonials.t6.name' }),
            desc: intl.formatMessage({ id: 'MLP.testimonials.t6.desc' }),
            content: intl.formatMessage({ id: 'MLP.testimonials.t6.text' }),
        },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const currentItem = items[currentIndex];
    const { name, desc, extra, content } = currentItem;

    const prev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        };
    };

    const next = () => {
        if (currentIndex + 1 < items.length) {
            setCurrentIndex(currentIndex + 1);
        };
    };

    return <div className={css.root}>
        <h3 className={css.title}>
            {intl.formatMessage({ id: 'MLP.testimonials.title' })}
        </h3>
        <div>
            <div className={css.testimonial}>
                <div className={css.content}>"{content}"</div>
                <div className={css.name}>{name}</div>
                <div className={css.desc}>{desc}</div>
                {extra ? <div className={css.desc}>{extra}</div> : null}
            </div>
            {items.length > 1 ? <div className={css.stepper}>
                <div
                    className={css.left}
                    onClick={prev}
                >
                    <ArrowIcon />
                </div>
                <div className={css.numbers}>
                    {items.map((item, index) => {
                        const isCurrent = index == currentIndex;
                        return <div
                            key={index}
                            className={css.number}
                            style={isCurrent ? { color: 'white' } : {}}
                        >
                            {index + 1}
                        </div>
                    })}
                </div>
                <div
                    className={css.right}
                    onClick={next}
                >
                    <ArrowIcon />
                </div>
            </div> : null}
        </div>
    </div>
};

export default SectionTestimonials;
